import React, { ComponentProps } from "react";
import { Link as GatsbyLink } from "gatsby";
import { HStack, Link } from "@chakra-ui/react";
import { Header } from "../Header";
import { TaggedLogo } from "../TaggedLogo";
import { isPartner, useUser } from "@utils";

export function HomePageHeader(props: ComponentProps<typeof Header>) {
  const { user } = useUser();

  return (
    <Header
      hasBreadcrumb={false}
      pos="sticky"
      top="0"
      zIndex="1"
      bg="bg"
      {...props}
    >
      <HStack spacing="8">
        <GatsbyLink to="/">
          <TaggedLogo isSmall />
        </GatsbyLink>
        <HStack
          display={{
            base: "none",
            md: "flex",
          }}
          as="nav"
          spacing="6"
          fontSize="lg"
          fontWeight="semibold"
        >
          <Link as={GatsbyLink} to="/browse">
            Tutorials
          </Link>
          <Link as={GatsbyLink} to="/#certifications">
            Certifications
          </Link>
          {user && isPartner(user) && (
            <Link as={GatsbyLink} to="/partners">
              Partners
            </Link>
          )}
        </HStack>
      </HStack>
    </Header>
  );
}
